module.exports = __webpack_public_path__ + "static/media/IMG_0761.11823954.JPG";